export const environment = {
	production: true,
  url: 'https://api.carrier.kosaas-c1.com:3001'
};
